import { Select } from 'antd'
import { STATUSES } from 'app/components/Core/LineItem/Table/hooks/useStatusFilter'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import { Dispatch, FC, SetStateAction } from 'react'

type FiltersProps = {
  value: IFilterStatus
  onChange: Dispatch<SetStateAction<IFilterStatus>>
}

const Filters: FC<FiltersProps> = ({ value, onChange }) => {
  const { tCore } = useTranslation({ scope: 'product_list', recordType: RecordType.line_item })

  const options = STATUSES.map((value) => ({
    label: tCore({ id: `${value}_machine` }),
    value
  }))
  return <Select options={options} value={value} onChange={onChange} />
}

export default Filters
